import { Injectable } from '@angular/core';
import { CheckoutActions } from '@checkout/data-access';
import { MyShopActions } from '@my-shop/data-access';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class MyShopEffects {
  // Сброс магазина в чекауте на любое изменения моего магазина
  resetShopOnSetMyShop$: Observable<CheckoutActions.ResetShop> = createEffect(() =>
    this.actions$.pipe(
      ofType(MyShopActions.SET_MY_SHOP_NAME),
      map(() => new CheckoutActions.ResetShop()),
    ),
  );

  constructor(private actions$: Actions) {}
}
